export default __webpack_public_path__ + "static/media/in.d4f5c6fb.png";